module.exports = "extended-content"